// Employee Custody (عُهد الموظفين) permission ids.
//
// These eight numbers are the central key service's APPROVAL NUMBERS, issued
// 21 September 2026, and `2026_09_21_000006_add_employee_custody_permissions.php`
// writes each one as its permission row's id — so the two must stay equal.
// They are read values, not derived ones: the block happens to sit at 1651-1658,
// which is not a rule (see the booking-contracts note in CLAUDE.md, where a
// predicted id was wrong two of the three times it was predicted).
//
// Confirm against a live tenant with:
//
//     SELECT id, name FROM permissions WHERE name LIKE 'employee_custodies.%' ORDER BY id;
export const EMPLOYEE_CUSTODIES_INDEX = 1651;
export const EMPLOYEE_CUSTODIES_CREATE = 1652;
export const EMPLOYEE_CUSTODIES_UPDATE = 1653;
// Approving and rejecting are the same trust — both answer the request — so
// they share one key, as the backend routes do.
export const EMPLOYEE_CUSTODIES_APPROVE = 1654;
// Its own key: this is the one that moves money and mints a payment voucher.
export const EMPLOYEE_CUSTODIES_DISBURSE = 1655;
// Its own key: accepting a receipt closes out a balance the office is owed.
export const EMPLOYEE_CUSTODIES_SETTLE = 1656;
export const EMPLOYEE_CUSTODIES_DELETE = 1657;
export const EMPLOYEE_CUSTODIES_RESTORE = 1658;
